import { CLink } from '@/CLink';
import { siteInfo } from '@/layout/NavLinks';
import { ReactComponent as PhoneIcon } from '@a/icons/phone.svg';
import styled from '@emotion/styled';
import { ReactNode } from 'react';
import SecondaryBtn from './SecondaryBtn';

const Btn = styled(SecondaryBtn)`
    background-color: #c2410c;
    color: #fff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

    > svg {
        margin: 0 8px 0 0;
        width: 20px;
        height: 20px;
        flex-shrink: 0;

        path {
            fill: #fff;
        }

        /* SecondaryBtn's trailing arrow */
        :last-of-type {
            display: none;
        }
    }

    :hover,
    :focus-visible {
        background-color: #b83702;
    }
`;

export const CallBtn = ({ className, children }: { className?: string; children?: ReactNode }) => (
    <Btn as={CLink} to={siteInfo.phone.link} className={className}>
        <PhoneIcon /> {children ?? siteInfo.phone.text}
    </Btn>
);

export default CallBtn;
